import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSendStyle0 = gravityIconIndividualCss;

const GravityIconSend = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0e7bc4755fe6133fc44b8a602c869388cc732920', color: this.color, size: this.size }, h("svg", { key: '0d989b808f96dd765f877ba0195be4469207edb4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'fbe0ba7805972c7082f6275ce52e8e475d459997', d: "M18.723 11.257a.5.5 0 0 0 0-.894l-14-7.001A.5.5 0 0 0 4 3.809V9.61l8.753 1.095c.292.036.292.46 0 .496L4 12.295v5.516a.5.5 0 0 0 .724.447l14-7Z", fill: "currentColor" }))));
    }
};
GravityIconSend.style = GravityIconSendStyle0;

export { GravityIconSend as gravity_icon_send };

//# sourceMappingURL=gravity-icon-send.entry.js.map